<template>
  <el-select v-model="bizType" size="mini">
    <el-option-group
      v-for="catalog in catalogs"
      :key="catalog.value"
      :label="catalog.text"
    >
      <template v-if="catalog.type">
        <el-option
          v-for="type in catalog.type.options"
          :key="type.value"
          :value="type.value"
          :label="type.text"
        />
      </template>
    </el-option-group>
  </el-select>
</template>
<script>
import { Select, OptionGroup, Option } from "element-ui";
import { CatalogChooser } from "@/components/excel/schema/label/catalog";

function findDefaultType(catalogs, catalog) {
  if (!Array.isArray(catalogs) || !catalogs.length) {
    return null;
  }
  const obj = catalogs.find((it) => it.value === catalog);
  if (obj === undefined) {
    return null;
  }
  if (obj.type) {
    return obj.type.default;
  }
  return null;
}
export default {
  name: "biz-type-selector",
  components: {
    [Select.name]: Select,
    [OptionGroup.name]: OptionGroup,
    [Option.name]: Option,
  },
  props: {
    value: {
      type: Number,
    },
  },
  model: {
    prop: "value",
    event: "change",
  },
  data() {
    const catalogs = CatalogChooser.options;
    const defaultType = findDefaultType(catalogs, CatalogChooser.default);
    const types = catalogs
      .map((it) => it.type)
      .filter((it) => it)
      .map((it) => it.options)
      .flat();
    return { catalogs, defaultType, types };
  },
  computed: {
    bizType: {
      get() {
        return this.value;
      },
      set(value) {
        if (value === "") {
          this.emitChangeType(null);
        } else {
          this.emitChangeType(value);
        }
      },
    },
  },
  watch: {
    value(type) {
      this.checkType(type);
    },
  },
  mounted() {
    this.checkType(this.value);
  },
  methods: {
    checkType(type) {
      if (type === null || type === undefined) {
        return;
      }
      if (!this.types.some((it) => it.value === type)) {
        this.emitChangeType(this.defaultType);
      }
    },
    emitChangeType(value) {
      this.$emit("update:value", value);
      this.$emit("change", value);
    },
  },
};
</script>
